import React from 'react';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import tciLogo from '@images/tci-logo-white.svg';

const ExclamationMark = () => (
  <svg
    aria-hidden
    className="tw-inline-block tw-ml-0.5"
    fill="white"
    height="0.75em"
    viewBox="0 0 60.45 91.77"
    width="0.5em"
  >
    <polygon
      points="0 91.77 3.22 76.66 60.45 64.85 60.45 62.56 6.26 62.56 16.7 0 44.16 0 27.84 62.56 22.34 91.77 0 91.77"
    />
  </svg>
);

interface DrawerHeaderProps {
  className?: string;
  programColor: string;
  programSubtitle?: string;
  programThumbnailUrl?: string;
  programTitle: string;
  showClose?: boolean;
  showLogo?: boolean;
}

const DrawerHeader = ({
  className,
  programColor,
  programSubtitle,
  programThumbnailUrl,
  programTitle,
  showClose = true,
  showLogo = false,
}: DrawerHeaderProps) => {
  const handleClose = () => {
    const hamburger = document.querySelector<HTMLButtonElement>('.reflow-hamburger');
    hamburger?.click();
  };

  return (
    <div
      className={cn(
        'tw-flex tw-items-center tw-gap-3 tw-min-h-[2.75rem] tw-py-1 tw-pr-3',
        'tw-text-white tw-overflow-hidden',
        className || 'reflow-drawer-header tw-hidden',
      )}
      style={{ backgroundColor: `#${programColor}` }}
    >
      {showClose && (
        <button
          aria-label="Close navigation menu"
          className={cn(
            'tw-bg-transparent tw-border-0 tw-text-white tw-cursor-pointer',
            'tw-p-2 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-rounded',
            'hover:tw-bg-white/10 focus:tw-outline focus:tw-outline-2 focus:tw-outline-white',
          )}
          type="button"
          onClick={handleClose}
        >
          <Icon icon="Close" size="1.5rem" />
        </button>
      )}
      {showLogo && (
        <img alt="TCI" className="tw-h-4 tw-flex-shrink-0" src={tciLogo} />
      )}
      {programThumbnailUrl && (
        <img
          alt=""
          className="tw-w-8 tw-h-8 tw-object-cover tw-flex-shrink-0"
          src={programThumbnailUrl}
        />
      )}
      <div
        aria-label={`${programTitle}${programSubtitle ? `, ${programSubtitle}` : ''}`}
        aria-level={2}
        className="tw-min-w-0 tw-flex tw-flex-col tw-gap-0"
        role="heading"
      >
        <span className="tw-font-bold tw-italic tw-text-base tw-leading-tight">
          {programTitle.replace(/!$/, '').trim()}
          {programTitle.endsWith('!') && <ExclamationMark />}
        </span>
        {programSubtitle && (
          <span className="tw-text-sm tw-opacity-80 tw-leading-tight">{programSubtitle}</span>
        )}
      </div>
    </div>
  );
};

export default DrawerHeader;
